export const fPhoneNumber = (phoneNumber: string) => {
	if (!phoneNumber) return "";
	const pn = phoneNumber.trim().replace(/\s/g, "");
	const pnOffset = pn.length - 10;
	let ret: string = pn.slice(0, pnOffset);

	for (let i = 0; i < pn.length - pnOffset; i++) {
		ret += pn[pnOffset + i];
		if (i !== 0 && i % 2 === 1) {
			ret += " ";
		}
	}
	return ret;
};
